import axios from 'axios';
import eventDispatcher from '../eventDispatcher'
import eventConfig from '@/configs/eventConfig';

export default class apiService {


    static get (url, token) {
        var params = {};
        if(token)
        {
            params.headers = {
                'Authorization': 'Bearer ' +token,
                "Content-Type": "application/json",
                };
        }

        
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL+url, params)
            .then(response => {
                resolve(response);
            })
            .catch(function (error) {
                console.log(error);
                //reject(error);
                
                
                if(error.response.status == 401)
                {
                    eventDispatcher.emit(eventConfig.UNAUTHORIZED);
                }else
                {
                    reject(error);
                }
                
            });
         });
       
    }

    

    static post (url, data, token) {

        var params = {};
        if(token)
        {
            params.headers = {
                'Authorization': 'Bearer ' +token,
                "Content-Type": "application/json",
                };
        }
        
        return new Promise((resolve, reject) => {
           
            axios.post(process.env.VUE_APP_API_URL+url, data, params)
            .then(response => {
                resolve(response);
            })
            .catch(function (error) {
                console.log(error);
                reject(error);
                
            });
         });
       
    }

}
